import React from "react";
import { Box, CircularProgress } from "@mui/material";
import TitleContainer from "./TitleContainer";

const Container = ({ icon, buttonIcon, title, onClick, children, ...props }) => {
  return (
    <Box sx={{ border: "1px solid #D0D5DE", borderRadius: "10px", position: "relative", overflow: "hidden", ...props.sx }}>
      <TitleContainer icon={icon} buttonIcon={buttonIcon} title={title} onClick={onClick} sx={{ position: "absolute", zIndex: 99 }}></TitleContainer>
      <Box sx={{ overflow: props.overflow || "auto", height: "100%" }}>
        <Box height={25}></Box>
        {props.isLoading ? (
          <Box width="100%" height="calc(100% - 25px)" display="flex" alignItems="center" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};

export default Container;
